import { render, staticRenderFns } from "./meetingRecordManagement.vue?vue&type=template&id=ef9da8bc&"
import script from "./meetingRecordManagement.vue?vue&type=script&lang=js&"
export * from "./meetingRecordManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports